<!-- nlc-style 404 Page -->
<div class="nlc-404-wrapper nlc-fade-in">
  <div class="nlc-container">
    <div class="nlc-404-content">
      <!-- 404 Icon -->
      <div class="error-icon-wrapper nlc-slide-up">
        <mat-icon class="error-icon">search_off</mat-icon>
      </div>

      <!-- Error Message -->
      <div class="error-message nlc-slide-up">
        <h1 class="nlc-heading-1 error-code">404</h1>
        <h2 class="nlc-heading-2">Seite nicht gefunden</h2>
        <p class="nlc-body-secondary">
          Die von Ihnen gesuchte Seite existiert nicht oder wurde verschoben.
        </p>
      </div>

      <!-- Navigation Options -->
      <div class="nlc-404-actions nlc-slide-up">
        <button class="nlc-button nlc-button-primary nlc-button-large" routerLink="/">
          <mat-icon>home</mat-icon>
          Zur Startseite
        </button>
        <button class="nlc-button nlc-button-secondary nlc-button-large" (click)="goBack()">
          <mat-icon>arrow_back</mat-icon>
          Zurück
        </button>
      </div>

      <!-- Helpful Links -->
      <div class="nlc-card helpful-links nlc-slide-up">
        <h3 class="nlc-heading-4">Hilfreiche Links</h3>
        <nav class="links-grid">
          <a routerLink="/orders" class="link-item">
            <mat-icon class="link-icon">shopping_cart</mat-icon>
            <span class="nlc-body-small">Bestellungen</span>
          </a>
          <a routerLink="/faq" class="link-item">
            <mat-icon class="link-icon">help_outline</mat-icon>
            <span class="nlc-body-small">FAQ</span>
          </a>
          <a routerLink="/feedback" class="link-item">
            <mat-icon class="link-icon">rate_review</mat-icon>
            <span class="nlc-body-small">Feedback</span>
          </a>
          <a routerLink="/impressum" class="link-item">
            <mat-icon class="link-icon">info</mat-icon>
            <span class="nlc-body-small">Impressum</span>
          </a>
        </nav>
      </div>
    </div>
  </div>
</div>
